import "./vyneInputRangePicker.scss";
import { Button, ConfigProvider, DatePicker, theme } from "antd";
import { defaultDateFormatString } from "utils/date";
// Due to RC Element Typing Not Being Passed Properly using this import vs get props util
import type { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;
const { useToken } = theme;

interface VyneInputRangePickerProps extends Omit<RangePickerProps, "picker" | "format" | "cellRender" | "components"> {
    readonly name: string;
}

/** Override for the AntD {@link RangePicker} component that applies common Vyne styles and configuration. */
export const VyneInputRangePicker = ({ className, presets, ...props }: Readonly<VyneInputRangePickerProps>) => {
    const { token } = useToken();

    // Force CSS of Presets
    if (presets) {
        presets = presets.map((preset) => ({
            label: <Button style={{ width: "100%", borderColor: token.colorInfo }}>{preset.label}</Button>,
            value: preset.value,
        }));
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    DatePicker: {
                        cellHeight: 32,
                        cellWidth: 32,
                        cellHoverBg: "transparent",
                        activeBorderColor: token.colorBorder,
                        activeShadow: token.boxShadow,
                    },
                },
            }}
        >
            <RangePicker
                {...props}
                cellRender={handleCellRender}
                className={`vyne-input-range-picker ${className ?? ""}`}
                format={defaultDateFormatString}
                picker="date"
                classNames={{
                    popup: {
                        root: "vyne-input-range-picker-popup",
                    },
                }}
                presets={presets}
            />
        </ConfigProvider>
    );
};

const handleCellRender: NonNullable<RangePickerProps["cellRender"]> = (current, info) => {
    if (info.type !== "date") {
        return info.originNode;
    }

    if (typeof current === "number" || typeof current === "string") {
        return <div className="ant-picker-cell-inner">{current}</div>;
    }

    return <div className="vyne-input-range-picker-cell ant-picker-cell-inner">{current.date()}</div>;
};
